import request from ".";
import { stringify } from "qs";
import { getAuthToken } from "../services/Auth";
import { headerConfig, headerConfigWithAuthorize } from "../services/Header";

export const requestRewards = async (requestParams) => {
  const response = await request.get(
    `/api/rewards/reward-item?${stringify(requestParams)}`,
    headerConfig()
  );
  return response.data;
};

export const requestRewardDetail = async (requestParams) => {
  const response = await request.get(
    `${process.env.GATSBY_NEW_API_URL}/api/v1/redemptions/${requestParams}`,
    headerConfigWithAuthorize(getAuthToken())
  );
  return response.data;
};

export const requestItemLocation = async (requestParams) => {
  const response = await request.get(
    `/api/rewards/reward-item/location?${stringify(requestParams)}`,
    headerConfig()
  );
  return response.data;
};

export const requestCategory = async (requestParams) => {
  const response = await request.get(
    `/api/rewards/reward-item/category?${stringify(requestParams)}`,
    headerConfig()
  );
  return response.data;
};

export const requestRewardsHistory = async (requestParams) => {
  const response = await request.get(
    `/api/rewards/transaction?${stringify(requestParams)}`,
    headerConfigWithAuthorize(getAuthToken())
  );
  return response.data;
};

export const redeemRewardItem = async (requestParams) => {
  const response = await request.post(
    `${process.env.GATSBY_NEW_API_URL}/api/v1/redemptions?${stringify(
      requestParams
    )}`,
    {},
    headerConfigWithAuthorize(getAuthToken())
  );

  return response;
};
